import { SubCategory } from "../../Domain/Model/SubCategory";
import { SubCategoryRepository } from "../../Domain/Repository/SubCategoryRepository";
import SubCategoryDataSource from "../DataSource/SubCategoryDataSource";

export class SubCategoryRepositoryImpl implements SubCategoryRepository {
  dataSource: SubCategoryDataSource;

  constructor(_datasource: SubCategoryDataSource) {
    this.dataSource = _datasource;
  }
  getSubCategories(): Promise<SubCategory[]> {
    return this.dataSource.getSubCategories();
  }
  
  createSubCategory(data: SubCategory): Promise<boolean> {
    return this.dataSource.createSubCategory(data);
  }
  updateSubCategory(data: SubCategory): Promise<boolean> {
    return this.dataSource.updateSubCategory(data);
  }
  
  removeSubCategory(id: string): Promise<boolean> {
    return this.dataSource.removeSubCategory(id);
  }
    
}